import { render, staticRenderFns } from "./FamilyPatientArchive.vue?vue&type=template&id=6916d24d&"
import script from "./FamilyPatientArchive.vue?vue&type=script&lang=js&"
export * from "./FamilyPatientArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports